<template>
	<div
		class="mb-4 mb-md-0 position-relative font-body"
		:style="{ color: isLoading ? 'lightgray' : 'inherit' }"
	>
		<div class="d-flex flex-row nowrap align-items-center justify-content-end">
			<div class="prestation-price heading text-grey-900 me-0">
				<PlaceholderBox
					v-if="isDisplayPlaceholders"
					:height="'20px'"
					:width="'60px'"
					:additionalClasses="'m-1'"
				/>
				<template v-else-if="pricePerPersonString">
					<span class="text-nowrap">
						{{ pricePerPersonString }} p.p
					</span>
				</template>
			</div>
		</div>
		<div class="d-flex flex-row nowrap align-items-center justify-content-end">
			<div
				v-if="crossedPrice > totalPrice && maxPromo && maxPromo >= 5 && !isDisplayPlaceholders"
				class="prestation-price crossed-price body text-grey-500 me-1"
				v-bind:class="addDnoneClassIfABtest"
			>
				<PlaceholderBox
					v-if="isDisplayPlaceholders"
					:height="'20px'"
					:width="'60px'"
					:additionalClasses="'m-1'"
				/>
				<template v-else-if="crossedPriceString && crossedPrice > totalPrice">
					<span class="text-nowrap">{{
						crossedPriceString
					}}</span>
				</template>
			</div>
 
			<div class="prestation-price body text-grey-900">
				<PlaceholderBox
					v-if="isDisplayPlaceholders"
					:height="'20px'"
					:width="'60px'"
					:additionalClasses="'m-1'"
				/>
				<template v-else-if="totalPriceString">
					<span class="text-nowrap">
						{{ totalPriceString }} total
					</span>
				</template>
			</div>

		</div>
		<div class="d-flex flex-row nowrap align-items-center justify-content-end">

			<PlaceholderBox
				v-if="isDisplayPlaceholders"
				:height="'20px'"
				:width="'40px'"
				:additionalClasses="'m-1'"
			/>
			<div
				v-if="crossedPrice >= totalPrice && maxPromo && maxPromo >= 5 && !isDisplayPlaceholders"
				class="prestation-discount-container d-flex align-items-center justify-content-center bg-primary-green me-2 me-md-1"
			>
				<div
					class="prestation-discount subcaption-strong text-primary-white px-2 py-1 text-nowrap"
					v-bind:class="addDnoneClassIfABtest"
				>
					-{{ discountString }}
				</div>
			</div>
			
			
		</div>
		

		<div class="loader-wrapper">
			<span
				v-if="!isDisplayPlaceholders && isLoading"
				class="price-loader price-loader-container"
			></span>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex"
import PlaceholderBox from "@/vue/planning/components/common/placeholderBox.vue"

import displayPrice from "@/displayPrice/displayPrice"
import store from "@/vue/planning/store/store"
import { isABtest } from "@/utils/utils"


export default {
	store,
	name: "PricesPP",
	props: {
		maxPromo: {
			type: Number,
			default: 0,
		},
		crossedPrice: {
			type: Number,
			default: 0,
		},
		totalPrice: {
			type: Number,
			default: 0,
		},
		perPrice: {
			type: Number,
			default: 0,
		},
		isDisplayPlaceholders: {
			type: Boolean,
			default: false,
		},
		totalParticipants: {
			type: Number,
			default: 1,
		},
		locale: {
			type: String,
			default: "fr_FR",
		},
		isLoading: Boolean,
	},
	components: {
		PlaceholderBox,
	},
	computed: {
		...mapState(["content"]),
		pricePerPersonString() {
			return (
				this.totalPrice &&
				this.displayPrice(parseInt(this.totalPrice)/this.totalParticipants * 100, this.locale)
			)
		},
		discountString() {
			return (
				this.totalPrice && this.crossedPrice && 
				this.displayPrice(parseInt(this.crossedPrice - this.totalPrice) * 100, this.locale)
			)
		},
		crossedPriceString() {
			return (
				this.crossedPrice &&
				this.displayPrice(parseInt(this.crossedPrice) * 100, this.locale)
			)
		},
		totalPriceString() {
			return (
				this.totalPrice &&
				this.displayPrice(parseInt(this.totalPrice) * 100, this.locale)
			)
		},
		perPriceString() {
			return (
				this.perPrice &&
				this.displayPrice(parseInt(this.perPrice) * 100, this.locale)
			)
		},
		addDnoneClassIfABtest() {
			const dNoneClass = isABtest() ? "d-none !important" : ""
			return dNoneClass
		},
	},

	methods: {
		displayPrice,
	},
}
</script>

<style scoped>
.prestation-discount-container {
	border-radius: 37px;
}
.loader-wrapper {
	top: 0;
	left: 0;
	position: absolute;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
}

.price-loader {
	height: 50px;
	background-size: 50px;
}

@keyframes rotation {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
}

/* .info-icon {
	z-index: ;
} */

.info-icon:hover + .package-info-container {
	visibility: visible;
}
.crossed-price {
	text-decoration: line-through;
}
@media (max-width: 1500px) and (min-width: 1201px) {
	.prestation-price {
		order: 2;
	}
	
	.font-weight-500.font-size-20 {
		order: 1;
		margin-bottom: 0.5rem !important;
	}
	
	.d-flex.flex-row.nowrap.align-items-center.justify-content-end {
		flex-direction: column !important;
		align-items: flex-end !important;
	}
}
</style>
